<template>
  <div :class="isMobile ? 'download-page download-page-m' : 'download-page'">
    <section class="download-hero">
      <div class="download-hero-inner">
        <div class="app-mark">AI</div>
        <div class="hero-content">
          <div class="hero-label">Android APK Download</div>
          <h1>艾感智能纸尿裤设备</h1>
          <p>用于智能纸尿裤设备连接、状态查看、通知提醒与设备管理。</p>
          <div class="hero-actions">
            <a
              class="download-button"
              :href="apkUrl"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              下载 Android APK
            </a>
            <a class="support-link" href="tel:0757-85335951">技术支持：0757-85335951</a>
          </div>
        </div>
      </div>
    </section>

    <section class="download-content">
      <div class="info-panel">
        <div class="section-title">App 信息</div>
        <div class="info-grid">
          <div v-for="item in appInfo" :key="item.label" class="info-item">
            <div class="info-label">{{ item.label }}</div>
            <div class="info-value">{{ item.value }}</div>
          </div>
        </div>
      </div>

      <div class="link-panel">
        <div class="section-title">相关协议</div>
        <div class="doc-links">
          <router-link :to="{ path: '/privacy-policy' }">隐私政策</router-link>
          <router-link :to="{ path: '/user-agreement' }">用户协议</router-link>
        </div>
      </div>

      <div class="install-panel">
        <div class="section-title">安装说明</div>
        <ol>
          <li v-for="item in installTips" :key="item">{{ item }}</li>
        </ol>
      </div>
    </section>
    <a class="record-number" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
      艾感科技（广东）有限公司 粤ICP备18012156号
    </a>
  </div>
</template>

<script>
export default {
  name: "AppDownload",
  data() {
    return {
      isMobile: window.innerWidth < 780,
      apkUrl: "https://www.aisensing.cn/apk/aigan-smartdiaper.apk",
      appInfo: [
        { label: "App 名称", value: "艾感智能纸尿裤设备" },
        { label: "版本号", value: "V1.0.0" },
        { label: "更新日期", value: "20260623" },
        { label: "APK 文件大小", value: "48.5MB" },
        { label: "适用客户/项目名称", value: "艾感智能纸尿裤设备" },
        { label: "开发主体/公司名称", value: "艾感科技（广东）有限公司" },
        { label: "客服/技术支持电话", value: "0757-85335951" }
      ],
      installTips: [
        "请确认下载地址为公司官方域名。",
        "请确认 App 名称、版本号、开发主体。",
        "首次安装需要允许“安装未知来源应用”。",
        "安装后按功能需要授权蓝牙、通知权限。",
        "后台连接时通知栏会显示运行状态。",
        "如手机管家提示风险，请联系技术支持并提供截图。"
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  methods: {
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  }
}
</script>

<style scoped lang="less">
.download-page {
  background: #f6f8fb;
  color: #26333d;
  padding-bottom: 70px;

  .download-hero {
    background: linear-gradient(135deg, #e9f7f6 0%, #f7fbff 52%, #eef2f8 100%);
    border-bottom: 1px solid #e2e8f0;
  }

  .download-hero-inner {
    max-width: 1120px;
    min-height: 340px;
    margin: 0 auto;
    padding: 58px 24px;
    display: flex;
    align-items: center;
    gap: 42px;
    box-sizing: border-box;
  }

  .app-mark {
    width: 132px;
    height: 132px;
    border-radius: 30px;
    background: #16b7a9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    font-size: 46px;
    font-weight: bold;
    box-shadow: 0 18px 38px rgba(22, 183, 169, 0.25);
  }

  .hero-content {
    text-align: left;
  }

  .hero-label {
    color: #0f8e83;
    font-size: 15px;
    line-height: 24px;
    font-weight: bold;
  }

  h1 {
    margin: 8px 0 12px;
    color: #1d2730;
    font-size: 38px;
    line-height: 52px;
    font-weight: bold;
    text-align: left;
  }

  p {
    max-width: 660px;
    margin: 0;
    color: #5c6873;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
  }

  .hero-actions {
    margin-top: 28px;
    display: flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
  }

  .download-button {
    min-width: 180px;
    height: 48px;
    padding: 0 28px;
    border-radius: 6px;
    background: #16b7a9;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    box-shadow: 0 10px 22px rgba(22, 183, 169, 0.24);
    box-sizing: border-box;
  }

  .support-link {
    color: #24566f;
    font-size: 15px;
    line-height: 26px;
  }

  .download-content {
    max-width: 1120px;
    margin: 34px auto 0;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .info-panel,
  .link-panel,
  .install-panel {
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 8px;
    margin-bottom: 18px;
    padding: 28px;
    box-sizing: border-box;
  }

  .section-title {
    color: #1d2730;
    font-size: 22px;
    line-height: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-top: 1px solid #edf2f7;
    border-left: 1px solid #edf2f7;
  }

  .info-item {
    min-height: 76px;
    padding: 16px 18px;
    border-right: 1px solid #edf2f7;
    border-bottom: 1px solid #edf2f7;
    box-sizing: border-box;
    text-align: left;
  }

  .info-label {
    color: #7a8794;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 6px;
  }

  .info-value {
    color: #27333d;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    word-break: break-all;
  }

  .doc-links {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    a {
      height: 40px;
      padding: 0 20px;
      border: 1px solid #16b7a9;
      border-radius: 6px;
      color: #0f8e83;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      box-sizing: border-box;
    }
  }

  ol {
    margin: 0;
    padding-left: 22px;
  }

  li {
    color: #4d5965;
    font-size: 16px;
    line-height: 32px;
    text-align: left;
    padding-left: 4px;
  }

  .record-number {
    display: block;
    margin: 28px auto 0;
    padding: 0 24px;
    color: #8b97a3;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    box-sizing: border-box;
  }
}

.download-page-m {
  padding-bottom: 1rem;

  .download-hero-inner {
    min-height: auto;
    padding: 0.9rem 0.4rem 0.7rem;
    display: block;
  }

  .app-mark {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 0.38rem;
    font-size: 0.58rem;
    margin-bottom: 0.46rem;
  }

  .hero-label {
    font-size: 0.32rem;
    line-height: 0.5rem;
  }

  h1 {
    font-size: 0.56rem;
    line-height: 0.78rem;
    margin: 0.12rem 0 0.2rem;
  }

  p {
    font-size: 0.34rem;
    line-height: 0.62rem;
  }

  .hero-actions {
    margin-top: 0.5rem;
    display: block;
  }

  .download-button {
    width: 100%;
    height: 1rem;
    font-size: 0.36rem;
  }

  .support-link {
    display: block;
    margin-top: 0.28rem;
    font-size: 0.32rem;
    line-height: 0.48rem;
  }

  .download-content {
    margin-top: 0.36rem;
    padding: 0 0.28rem;
  }

  .info-panel,
  .link-panel,
  .install-panel {
    border-radius: 0.12rem;
    padding: 0.42rem 0.32rem;
    margin-bottom: 0.28rem;
  }

  .section-title {
    font-size: 0.44rem;
    line-height: 0.58rem;
    margin-bottom: 0.32rem;
  }

  .info-grid {
    display: block;
    border-left: none;
  }

  .info-item {
    min-height: auto;
    padding: 0.28rem 0;
    border-right: none;
  }

  .info-label {
    font-size: 0.28rem;
    line-height: 0.42rem;
  }

  .info-value {
    font-size: 0.34rem;
    line-height: 0.52rem;
  }

  .doc-links {
    display: block;

    a {
      width: 100%;
      height: 0.88rem;
      font-size: 0.32rem;
      margin-bottom: 0.2rem;
    }
  }

  ol {
    padding-left: 0.42rem;
  }

  li {
    font-size: 0.32rem;
    line-height: 0.58rem;
  }

  .record-number {
    display: block;
    margin-top: 0.42rem;
    padding: 0 0.28rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}
</style>
